import React from "react";
import { Grid, Text, Paper } from "@mantine/core";

const SummaryItem = ({ label, value }) => (
  <div>
    <Text size="xs" color="dimmed" mb={4}>
      {label}
    </Text>
    <Text size="sm" weight={500}>
      {value ?? "—"}
    </Text>
  </div>
);

const yesNo = (value) => (value ? "Yes 是" : "No 否");

const OrderArFormProductDetails = ({ form }) => {
  const { fundName, riskRating, trailerFee, complexProduct, affiliatedFwd } =
    form?.values ?? {};

  if (!String(fundName ?? "").trim()) return null;

  return (
    <Paper withBorder p="lg" radius="sm" mt="md">
      <Text size="xs" color="dimmed" mb="md">
        Selected fund 已選基金
      </Text>
      <Text size="sm" weight={600} mb="lg">
        {fundName}
      </Text>

      <Grid gutter="lg">
        <Grid.Col span={12} sm={6}>
          <SummaryItem
            label="Risk Rating (1–5) 風險評級"
            value={riskRating ?? "—"}
          />
        </Grid.Col>
        <Grid.Col span={12} sm={6}>
          <SummaryItem
            label="Trailer Fee / Access Fee % 後續費用"
            value={trailerFee != null ? `${trailerFee}%` : "—"}
          />
        </Grid.Col>
        <Grid.Col span={12} sm={6}>
          <SummaryItem
            label="Complex Product #1 複雜產品"
            value={yesNo(complexProduct)}
          />
        </Grid.Col>
        <Grid.Col span={12} sm={6}>
          <SummaryItem
            label="Affiliated company #2 聯繫公司"
            value={yesNo(affiliatedFwd)}
          />
        </Grid.Col>
      </Grid>
    </Paper>
  );
};

export default OrderArFormProductDetails;
